export function getLines(rowHeight) {
    return Math.max(Math.floor(rowHeight / 24), 1);
}
